import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    genders: [],
    filterData: undefined
})

const getters = {}

const actions = {
    // ─── Customers (users) ───────────────────────────────────────────
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)
        state.filterData = filterData

        let params = {page: page?.current, page_limit: page?.pageSize}
        if (state.filterData) params = {...params, ...state.filterData}

        const res = await this._vm.axios.get(this._vm.endpoint.get('user'), {params})
        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => commit('setLoading', false), 250)
    },

    refresh({state, dispatch}) {
        dispatch('get', {page: state.table.pagination, filterData: state.filterData})
    },

    async show({commit}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('user') + '/' + id)
        return response.data.data
    },

    async create({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('user'), data)
        return response.data
    },

    async put({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('user') + '/' + id, data)
        return response.data
    },

    async delete({commit, dispatch}, {id}) {
        let successDeleted = []
        if (!id || id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoint.get('user') + '/' + id[i])
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'))
                    successDeleted.push(id[i])
                } else {
                    this._vm.$message.error(data.message)
                }
            }
            dispatch('refresh')
            return successDeleted
        }
    },

    async changePassword({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('user_change_password') + '/' + id, data)
        return response.data
    },

    async selfLogin({commit}, {id}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('user_self_login'), {user_id: id})
        return response.data
    },

    async exportList({state}, {filterData} = {}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('user_export'), {
            params: filterData ?? state.filterData ?? {},
            responseType: 'blob',
        })
        return response
    },

    // B2B onay / red
    async b2bApprove(_, {id}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('user') + '/' + id + '/b2b-approve')
        return response.data
    },
    async b2bReject(_, {id}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('user') + '/' + id + '/b2b-reject')
        return response.data
    },

    // ─── Genders ─────────────────────────────────────────────────────
    async getGenders({commit}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('user_gender'))
        commit('updateGenders', response.data.data || [])
        return response.data.data || []
    },

    // ─── Addresses ───────────────────────────────────────────────────
    async getAddresses({commit}, {user_id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('user_address'), {params: {user_id}})
        return response.data.data || []
    },

    async addAddress({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('user_address'), data)
        return response.data
    },

    async updateAddress({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('user_address') + '/' + id, data)
        return response.data
    },

    async deleteAddress({commit}, {id}) {
        const response = await this._vm.axios.delete(this._vm.endpoint.get('user_address') + '/' + id)
        return response.data
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updateGenders(state, data) {
        state.genders = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
